<article
  [ngStyle]="{ color: 'var(' + color() + ')' }"
  class="relative flex w-full items-center">
  @if (routerLink()) {
    <a
      class="absolute left-0 cursor-pointer md:static md:mr-2"
      [routerLink]="[routerLink()]">
      <icon name="arrow-left-icon" />
    </a>
  }

  <div class="mx-auto text-center md:mx-0 md:text-left">
    <p class="font-barlow text-xl leading-7 font-bold italic">
      {{ title() }}
    </p>

    @if (urls().length > 1) {
      <p class="text-blue-ocean font-barlow text-sm leading-4 font-semibold italic">
        @for (url of urls(); track $index; let last = $last) {
          <a [routerLink]="url.url">{{ url.title }}</a>

          @if (!last) {
            <span> / </span>
          }
        }
      </p>
    }
  </div>
</article>
